/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPromoTokensResponseAllOf,
    GetPromoTokensResponseAllOfFromJSON,
    GetPromoTokensResponseAllOfFromJSONTyped,
    GetPromoTokensResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PromoToken,
    PromoTokenFromJSON,
    PromoTokenFromJSONTyped,
    PromoTokenToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetPromoTokensResponse
 */
export interface GetPromoTokensResponse extends PaginatedResponse {
    /**
     * 
     * @type {Array<PromoToken>}
     * @memberof GetPromoTokensResponse
     */
    promoTokens: Array<PromoToken>;
}

export function GetPromoTokensResponseFromJSON(json: any): GetPromoTokensResponse {
    return GetPromoTokensResponseFromJSONTyped(json, false);
}

export function GetPromoTokensResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromoTokensResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PaginatedResponseFromJSONTyped(json, ignoreDiscriminator),
        'promoTokens': ((json['promoTokens'] as Array<any>).map(PromoTokenFromJSON)),
    };
}

export function GetPromoTokensResponseToJSON(value?: GetPromoTokensResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PaginatedResponseToJSON(value),
        'promoTokens': ((value.promoTokens as Array<any>).map(PromoTokenToJSON)),
    };
}


